import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform, NavParams } from '@ionic/angular';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { RoutingService } from 'src/app/services/routing/routing.service';

export interface IKBAQuestionsAndAnswer {
  type: string;
  prompt: string;
  answers: string[];
}

export type IKBAQuestionsAndAnswersObj = IKBAQuestionsAndAnswer[];

@Component({
  selector: 'app-idology-kba',
  templateUrl: './idology-kba.component.html',
  styleUrls: ['./idology-kba.component.scss'],
})
export class IdologyKbaComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

  public idologyKbaForm: FormGroup;
  public questionsAndAnswersObj: IKBAQuestionsAndAnswersObj;
  private currentCustomer: CustomerModel;
  public kbaStatus: string;

  public errorMessage: string = '';
  public startKba: boolean = false;
  public kbaSubmitted: boolean = false;
  public isIOSApp: boolean;
  public environmentName: string;

  // refactor later? copied from signup-step-two
  public registrationSuccessful: boolean = false;

  private closingModal: boolean = false;
  private kyc_attempts = 0;
  isSMS_OR_AuthApp;

  constructor(
    public authenticationService: AuthenticationService,
    private eventsService: EventsService,
    private fb: FormBuilder,
    private navparams: NavParams,
    public platform: Platform,
    public successMessageService: SuccessMessageService,
    private userSessionService: UserSessionService,
    private webservice: WebservicesService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    protected configService: ConfigService,
    private routing: RoutingService,
  ) {
    this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
      this.currentCustomer = customer;
    });
  }

  ngOnInit() {
    this.successMessageService.clearMessage();

    //TO DO - update with capacitor - Mobile Team
    this.isIOSApp = this.platform.is("cordova") && this.platform.is("ios");

    this.idologyKbaForm = this.fb.group({
      answer1: ['', [Validators.required]],
      answer2: ['', [Validators.required]],
      answer3: ['', [Validators.required]],
      answer4: ['', [Validators.required]],
      answer5: ['', [Validators.required]],
      // qna: this.fb.array([])
    });

    this.onStartKba();
  }

  ngOnDestroy() {
    if (!this.closingModal) {
      this.closeModal();
    }
  }

  ionViewDidEnter() {
    this.eventsService.publish("event:lobby:show");
  }

  public onDropdownBlur = () => {
    // (ionBlur) on <ion-select>
    this.onDropdownClick();
  }

  public onDropdownClick = () => {
    // (click) on <ion-select>
    if (this.isIOSApp) {
      // Forces scrolling a tiny bit to keep ios from locking scroll
      /* this.content.scrollTo(0, this.content.getScrollElement().scrollTop + 1, 0, () => {
         this.content.scrollTo(0, this.content.getScrollElement().scrollTop - 1, 0);
       });*/
      this.content.scrollToTop();
    }
  }

  public onDropdownCancel = () => {
    // (ionCancel) on <ion-select>
    this.onDropdownClick();
  }

  public onDropdownChange = () => {
    // (ionChange) on <ion-select>
    this.onDropdownClick();
  }

  public onSubmit = () => {
    this.kbaSubmitted = true;
    this.postVerifyCustomerAnswers();
  }

  public onStartKba = () => {
    this.startKba = true;

    // Populate the page with questions
    this.getKbaQuestions();
  }

  public onStartScanVerify = () => {
    this.navigator.navigateTo("ScanVerifyPage", { forceModal: true });
  }

  public onSuccess = () => {
    this.routing.defaultRoute();
  }

  public getKbaQuestions = () => {
    let obj = {
      'session_token': this.userSessionService.getSessionToken()
    }

    this.webservice.get('/kyc/get-kba-questions', obj).subscribe({
      next: (response: any) => {
        if (response && !!response.result) this.questionsAndAnswersObj = response.payload.questions;
      },
      error: (error: any) => {
        console.error('getKbaQuestions: error', error);
      }
    });
  }

  public postVerifyCustomerAnswers = () => {
    let obj = {
      // example
      // session_token=jSpqWj-r8wUWdu-PD0V1msTGmsOuA6S4rytp7u4VsU7yg2-2MZ3u2w
      // question1=previous.address
      // answer1=None of the above
      // question2=city.of.residence
      // answer2=None of the above
      // question3=purchased.property.from
      // answer3=JOE ANDERSON
      // question4=person.known.fic
      // answer4=None of the above
      // question5=property.size
      // answer5=Over 2,500
      'answer1': this.idologyKbaForm.get('answer1').value,
      'answer2': this.idologyKbaForm.get('answer2').value,
      'answer3': this.idologyKbaForm.get('answer3').value,
      'answer4': this.idologyKbaForm.get('answer4').value,
      'answer5': this.idologyKbaForm.get('answer5').value,
      'question1': this.questionsAndAnswersObj[0].type,
      'question2': this.questionsAndAnswersObj[1].type,
      'question3': this.questionsAndAnswersObj[2].type,
      'question4': this.questionsAndAnswersObj[3].type,
      'question5': this.questionsAndAnswersObj[4].type,
      'session_token': this.userSessionService.getSessionToken()
    }

    this.webservice.post('kyc/verify-customer-answers', obj).subscribe({
      next: (response: any) => {
        // let data = JSON.parse(response);
        if (response && !!response.result) {
        }

        this.kbaStatus = response.payload.kyc_step;

        if (this.kbaStatus) {
          this.kbaStatus = this.kbaStatus.toLowerCase();
        }
        if (response?.payload?.kyc_attempts) {
          this.kyc_attempts = response.payload.kyc_attempts;
        }
        this.closeModal();
      },
      error: (error: any) => {
        console.error("kyc server error", error);
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.closingModal = true;
    switch (this.kbaStatus) {
      case 'pending_idscan':
        // User gets less than 3 questions correct
        // this.errorMessage = 'We could not complete the authentication and we now need you to scan your ID and a take a selfie.';
        this.onStartScanVerify();
        break;
      case 'pending_retry':
        // User does not answer questions in a predetermined amount of time (Idology setting)
        // this.errorMessage = 'Oops. That took too long. We could not complete the authentication and we now need you to scan your ID and a take a selfie.';
        this.navigator.navigateTo("InvalidKycComponent", {}, { kyc_attempts: this.kyc_attempts });
        break;
      case 'pending_sovos':
        this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true });
        break;
      case 'pending_cs':
        this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true });
        break;
      case 'done':
        // User gets 3 or more questions correct
        // this.successMessageProvider.setMessage("Passed. Thank you for taking the time.");

        setTimeout(() => {
          this.doMFA();
        }, 1000);

        break;
      default:
        this.continueKBAFailed();
        break;
    }
  }

  continueKBAFailed() {
    if (!!this.currentCustomer && this.currentCustomer.status === "active") return this.doMFA();
    //return Navigator.navigateTo("LogoutPage", {}, {code: 'QUALIFICATION_KBA_UNFINISHED', reason: 'QUALIFICATION_KBA_UNFINISHED'});;
    this.navigator.dismissAll();
    return this.logoutService.onLogout();
  }

  get isMobile() {
    return (this.platform.is('mobile') || this.platform.is('mobileweb')) ? true : false;
  }

  private doMFA = () => {
    const MFAStatus = this.userSessionService.getMFAApproval();
    if (MFAStatus == "true") {
      return this.activateCustomer();
    } else {
      const customer_id = this.authenticationService.customer.customerId;
      // event for successful signup
      //this.eventsService.publish('event:signupcomplete', { customer_id: customer_id });
      //this.eventsService.publish('event:login', { customer_id: customer_id });
      this.isSMS_OR_AuthApp;
      const kycStepValue = this.getKycStepValue(this.currentCustomer);
      console.log(kycStepValue)

      if (kycStepValue) {
        this.isSMS_OR_AuthApp = kycStepValue == 'SMS' ? 'SMS' : 'AUTH_APP'
      } else {
        this.isSMS_OR_AuthApp = this.configService.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
      }

      console.log(this.isSMS_OR_AuthApp)

      if (this.userSessionService.getLoginResponseForMFA()) {
        this.userSessionService.setMFAStatus(eMfaStatuses.required)
        localStorage.setItem('MFA.signup', 'true');
        if (this.isSMS_OR_AuthApp == 'SMS') {
          this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer_id, callback: this.activateCustomer })
        } else {
          this.navigator.navigateTo("AuthenticatorAppLoginComponent", { forceModal: true }, { customerId: customer_id, callback: this.activateCustomer })
        }
      } else {
        return this.activateCustomer();
      }
    }
  }

  activateCustomer = () => {
    this.eventsService.publish('event:signupResult:flag');
    this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
  }

  getKycStepValue(customerResponse): any | false {
    const kycStepData = customerResponse.customData.find(data => data.key === 'MFA_METHOD');
    return kycStepData ? kycStepData.value : false;
  }

}
